import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useDigitalReplicaAccess } from "@/hooks/useDigitalReplicaAccess";

/**
 * Route guard: renders children only while the digital replica feature flag
 * AND the account's beta-tester flag are both on. Otherwise the URL behaves
 * as if the page never existed.
 */
export function ReplicaRoute({ children }: { children: ReactNode }) {
  const { enabled, loading } = useDigitalReplicaAccess();

  if (loading) {
    return (
      <div className="min-h-dvh flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!enabled) return <Navigate to="/" replace />;

  return <>{children}</>;
}

export default ReplicaRoute;
